/* eslint-disable max-len */
import { ICoinPageData } from 'pages/loans/[coin]/assets/page-data/types'

import mkrQuestions from 'images/coin-pages/questions/mkr.svg'

import { commonSlidesData } from '../commonPageData'

export const mkrPage: ICoinPageData = {
  title: 'coin_694',
  description: 'coin_695',
  // description: 'coin_696',
  h1: (t, _, replacePlaceholders) => (
    <span dangerouslySetInnerHTML={{ __html: replacePlaceholders(t('get_instant_coin_loan'), { coin: 'Maker' }) }} />
  ),
  questionsBlock: {
    image: mkrQuestions,
    questions: [
      {
        title: 'coin_697',
        answer: 'coin_698',
      },
      {
        title: 'coin_699',
        answer: 'coin_700',
      },
      {
        title: 'coin_701',
        answer: 'coin_702',
      },
      {
        title: 'coin_703',
        answer: 'coin_704',
      },
    ],
  },
  whatIs: {
    ...commonSlidesData('Maker (MKR)'),
    text: [],
    blogCards: [
      {
        link: 'https://coinrabbit.io/blog/how-to-lend-maker/',
        image:
          'https://sp-ao.shortpixel.ai/client/to_webp,q_lossless,ret_img,w_1185/https://coinrabbit.io/blog/wp-content/uploads/2022/01/integration-94CR_LQ.png',
        imageAlt: 'How to get an instant loan using your Maker?',
      },
      {
        link: 'https://coinrabbit.io/blog/how-to-earn-interest-on-stablecoins/',
        image:
          'https://sp-ao.shortpixel.ai/client/to_webp,q_lossless,ret_img,w_1185/https://coinrabbit.io/blog/wp-content/uploads/2021/09/Feature_Image_How-to-ern-interest-on-stablecoins.png',
        imageAlt: 'How to earn interest on Stablecoins?',
      },
      {
        link: 'https://coinrabbit.io/blog/what-types-of-crypto-loans-are-there-and-how-can-i-profit-from-it/',
        image:
          'https://sp-ao.shortpixel.ai/client/to_webp,q_lossless,ret_img,w_1185/https://coinrabbit.io/blog/wp-content/uploads/2021/12/1.png',
        imageAlt: 'What types of crypto loans are there and how can I profit from it?',
      },
    ],
    paragraphs: [
      {
        title: 'coin_705',
        text: ['coin_707'],
      },
      {
        title: 'coin_706',
        text: ['coin_708'],
      },
    ],
  },
}
